module.exports = __webpack_public_path__ + "static/img/5.1809966.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/5.png
// module id = Rl+E
// module chunks = 0